<template>
    <div class="knowledge-ranking">
        <div class="knowledge-ranking_title">
            <span>知识考核</span>
        </div>

        <div class="knowledge-ranking_filter">
            <div class="filter-select">
                <!-- 个人、班级 -->
                <el-select v-model="type" placeholder="请选择" style="width: 250px" class="type-select" @change="handleTypeChange">
                    <el-option label="个人统计" :value="1"></el-option>
                    <el-option label="班级统计" :value="2"></el-option>
                </el-select>

                <el-cascader
                    v-model="courseValue"
                    :options="courseOptions"
                    :props="cascProp"
                    @change="handleChapterChange"
                    :show-all-levels="false"
                ></el-cascader>

                <!-- 试卷列表 -->
                <el-select v-model="paper_id" placeholder="请选择" style="width: 250px" class="paper-select" @change="handlePaperChange">
                    <el-option v-for="item in paperList" :key="item.paper_id" :label="item.paper_name" :value="item.paper_id"> </el-option>
                </el-select>
            </div>

            <el-button type="primary" @click="$router.back()">返回</el-button>
        </div>

        <el-scrollbar class="knowledge-ranking_box">
            <div class="personal-ranking" v-if="type === 1">
                <div class="personal-ranking_top">
                    <template v-if="knowldegePersonData.list.length > 0">
                        <div class="top-title">知识考核个人排名</div>

                        <div class="top-chart" ref="knowledgePersonChartRef"></div>
                    </template>

                    <div class="box-empty" v-else>
                        <img src="@/assets/images/discussion-empty.png" alt="" />
                        <span>暂无数据</span>
                    </div>
                </div>

                <div class="personal-ranking_bottom">
                    <div class="score-item" v-for="scoreItem in scoreOptions" :key="scoreItem.key">
                        <div class="score-item_top">
                            <div class="top-label">{{ scoreItem.label }}</div>
                        </div>

                        <div class="score-item_bottom">
                            <el-progress
                                type="circle"
                                :percentage="knowldegePersonData[scoreItem.key]"
                                :width="160"
                                :stroke-width="12"
                                stroke-linecap="butt"
                                :color="scoreItem.color"
                                :show-text="false"
                            ></el-progress>

                            <div class="progress-text">{{ knowldegePersonData[scoreItem.key] }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="class-statictis" v-if="type === 2">
                <div class="class-statictis_chart">
                    <div class="top-title">
                        <span>客观题正确率</span>
                        <span class="desc">正确率(%)</span>
                    </div>

                    <div class="top-chart" ref="knowledgeClassChartRef"></div>
                </div>

                <div class="class-statictis_question" v-if="currentQuestion">
                    <div class="question-detail">
                        <!-- 题号 -->
                        <div class="question-detail_index">第{{ questionIndex + 1 }}题：</div>

                        <!-- 题目 -->
                        <div class="question-detail_content">
                            <div class="content-title">{{ getQuestionTitle }}</div>

                            <div class="content-answer">
                                <!-- 单选题 -->
                                <template v-if="[1, 2, 3].includes(currentQuestion.topic_type)">
                                    <div class="answer-item" v-for="(answer, index) in getAnswerList" :key="index">{{ answer }}</div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <div class="question-statictis">
                        <div class="statictis-item current-answer" ref="correntAnswerRef">
                            <span class="statictis-item_label">正确答案：</span>

                            <el-popover
                                placement="top"
                                width="600"
                                trigger="hover"
                                :content="getCorrectAnswer"
                                popper-class="dark-popover"
                                :disabled="!questionAskPoppver"
                            >
                                <span class="statictis-item_value" slot="reference">{{ getCorrectAnswer }}</span>
                            </el-popover>
                        </div>

                        <div class="statictis-item current-rate">
                            <span class="statictis-item_label">正确率：</span>
                            <span class="statictis-item_value">{{ currentQuestion.student_answer_right_rate }}</span>
                        </div>

                        <div class="statictis-item current-count">
                            <span class="statictis-item_label">正确人数：</span>
                            <span class="statictis-item_value">{{ currentQuestion.student_answer_right_num }}</span>
                        </div>

                        <div class="statictis-item fail-count">
                            <span class="statictis-item_label">错误人数：</span>
                            <span class="statictis-item_value">{{ currentQuestion.student_answer_wrong_num }}</span>
                        </div>

                        <div class="statictis-item no-make-count">
                            <span class="statictis-item_label">未做人数：</span>
                            <span class="statictis-item_value">{{ currentQuestion.student_no_answer_num }}</span>
                        </div>
                    </div>
                </div>

                <div class="class-statictis_rate">
                    <div
                        :class="['score-item', `question-type-${questionTypeList.length}`]"
                        v-for="item in questionTypeList"
                        :key="item.key"
                    >
                        <div class="score-item_top">
                            <div class="top-label">{{ item.label }}正确率</div>
                        </div>

                        <div class="score-item_bottom">
                            <el-progress
                                type="circle"
                                :percentage="Number.parseFloat(knowledgeClassData[item.key])"
                                :width="questionTypeList.length > 3 ? 100 : 160"
                                :stroke-width="questionTypeList.length > 3 ? 8 : 12"
                                stroke-linecap="butt"
                                :color="item.color"
                                :show-text="false"
                            ></el-progress>

                            <div class="progress-text">{{ knowledgeClassData[item.key] }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
export default {
    name: "KnowledgeRanking",
    data() {
        return {
            paper_id: undefined,
            paperList: [],
            type: 1, // 1-个人，2-班级
            scoreOptions: [
                { key: "max_score", label: "最高分", color: "#165DFF" },
                { key: "avg_score", label: "平均分", color: "#4FD1C5" },
                { key: "min_score", label: "最低分", color: "#FEAE65" },
            ],
            knowldegePersonData: {
                list: [],
                max_score: 0,
                avg_score: 0,
                min_score: 0,
            },
            knowledgeClassData: {
                topics: {
                    single: [], // 单选题
                    multiple: [], // 多选题
                    judge: [], // 判断题
                    fill_blank: [], // 填空题
                    ask_answer: [], // 问答题
                },
                single_right_rate: "0%", // 单选题正确率
                multiple_right_rate: "0%", // 多选题正确率
                judge_right_rate: "0%", // 判断题正确率
                fill_blank_right_rate: "0%", // 填空题正确率
                ask_answer_right_rate: "0%", // 问答题正确率
            },
            chartMap: new Map(),
            questionTypeMap: new Map([
                ["single", { key: "single_right_rate", color: "#165DFF", label: "单选题" }],
                ["multiple", { key: "multiple_right_rate", color: "#4FD1C5", label: "多选题" }],
                ["judge", { key: "judge_right_rate", color: "#FEAE65", label: "判断题" }],
                ["fill_blank", { key: "fill_blank_right_rate", color: "#165DFF", label: "填空题" }],
                ["ask_answer", { key: "ask_answer_right_rate", color: "#4FD1C5", label: "问答题" }],
            ]),
            questionTypeList: [], // 试卷题型类型列表
            questionIndex: 0,
            questionId: undefined,
            currentQuestion: null,
            questionAskPoppver: false,
            courseOptions: [],
            courseValue: [],
            cascProp: { label: "name", children: "children", value: "index" },
        };
    },
    created() {
        // this.getPaperList();

        this.getCourseList();
    },
    mounted() {
        window.addEventListener("resize", this.resizeChart);
    },
    computed: {
        // 获取题目标题
        getQuestionTitle() {
            try {
                const htmlString = this.currentQuestion.topic.title;
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, "text/html");

                return doc.body.textContent || doc.body.innerText;
            } catch (error) {
                console.log("question title error: ", error);
                return "";
            }
        },

        // 获取题目正确答案
        getCorrectAnswer() {
            const optionsObj = {
                0: "A",
                1: "B",
                2: "C",
                3: "D",
            };
            this.questionAskPoppver = false;

            try {
                if ([1, 3].includes(this.currentQuestion.topic_type)) {
                    // 单选题/判断题
                    return optionsObj[this.currentQuestion.topic.options.value];
                } else if (this.currentQuestion.topic_type === 2) {
                    // 多选题
                    let result = "";

                    this.currentQuestion.topic.options.value.forEach((item, index) => {
                        if (index !== 0) result += "、";
                        result += optionsObj[item];
                    });

                    return result;
                } else if (this.currentQuestion.topic_type === 4) {
                    // 填空题
                    let result = "";

                    this.currentQuestion.topic.options.option.forEach((item, index) => {
                        if (index !== 0) result += "、";

                        result += item.name || item || "";
                    });

                    return result;
                } else if (this.currentQuestion.topic_type === 5) {
                    // 问答题
                    this.$nextTick(() => {
                        this.setAnswerPoppver();
                    });
                    return this.currentQuestion.topic.analyse || "";
                } else {
                    return "";
                }
            } catch (error) {
                console.log("question correctAnswer error: ", error);
                return "";
            }
        },

        // 获取题目选项列表
        getAnswerList() {
            try {
                // 单选题
                const answerOptionsWord = ["A", "B", "C", "D", "E", "F", "G", "H"];
                const answerList = [];
                this.currentQuestion.topic.options.option.forEach((item, index) => {
                    answerList.push(`${answerOptionsWord[index]}：${item.name}`);
                });

                return answerList;
            } catch (error) {
                console.error("question answerList error: ", error);
                return [];
            }
        },
    },
    methods: {
        // 获取课程列表
        getCourseList() {
            // /admin/cefinoorsu;
            const params = {
                id: Number(this.$route.query.course_id),
            };

            this.$shttp.axiosGetBy(this.$api.courseContent, params, (res) => {
                if (res.code === 200) {
                    const courseContent = res.data.course_content;
                    this.formatterCourseList(courseContent);

                    this.courseOptions = courseContent;
                    this.courseValue = [0, 0];

                    this.getPaperList();
                }
            });
        },

        formatterCourseList(courseList) {
            for (let i = 0; i < courseList.length; i++) {
                const courseItem = courseList[i];

                if (!!courseItem.id) return false;

                courseItem.index = i;

                if (courseItem.children && courseItem.children.length > 0) {
                    if (!this.formatterCourseList(courseItem.children)) {
                        delete courseItem.children;
                    }
                }
            }

            return true;
        },

        // 获取试卷列表
        getPaperList() {
            if (this.courseValue.length < 2) return;

            const params = {
                c_id: Number(this.$route.query.class_id),
                course_id: Number(this.$route.query.course_id),
                course_chapter: this.courseValue[0],
                course_node: this.courseValue[1],
            };

            this.$shttp.axiosGetBy(this.$api.evaluation_knowledge_paper_list, params, (res) => {
                if (res.code === 200) {
                    this.paperList = res.data.list || [];

                    if (this.paperList.length > 0) {
                        this.paper_id = this.paperList[0].paper_id;

                        this.getKnowledgeData();
                    } else {
                        this.currentQuestion = null;
                        this.questionId = undefined;
                        this.questionIndex = 0;
                        this.paper_id = undefined;
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // 获取知识考核数据
        getKnowledgeData() {
            const params = {
                course_id: Number(this.$route.query.course_id),
                course_chapter: this.courseValue[0],
                course_node: this.courseValue[1],
                paper_id: this.paper_id,
                c_id: Number(this.$route.query.class_id),
            };
            let apiPath = "";
            if (this.type === 1) apiPath = this.$api.evaluation_knowledge_list;
            else if (this.type === 2) apiPath = this.$api.evaluation_knowledge_statistics;

            this.$shttp.axiosGetBy(apiPath, params, (res) => {
                if (res.code === 200) {
                    if (this.type === 1) {
                        // 个人排名
                        this.knowldegePersonData = res.data;

                        this.knowldegePersonData.list = this.knowldegePersonData.list.sort((a, b) => {
                            return b.score - a.score;
                        });

                        this.$nextTick(() => {
                            this.setPersonChart();
                        });
                    } else if (this.type === 2) {
                        // 班级数据
                        this.knowledgeClassData = res.data;
                        this.questionTypeList = [];

                        for (const [key, value] of Object.entries(this.knowledgeClassData.topics)) {
                            if (value.length > 0) {
                                const questionType = this.questionTypeMap.get(key);

                                this.questionTypeList.push({
                                    key: questionType.key,
                                    label: questionType.label,
                                    color: questionType.color,
                                });
                            }
                        }

                        this.$nextTick(() => {
                            this.setClassChart();
                        });
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        handleChapterChange(val) {
            this.courseValue = val;
            this.getPaperList();
        },

        // 获取问题详情-得到当前显示的题目
        getQuestionDetail() {
            const questionList = [];
            for (const [_, value] of Object.entries(this.knowledgeClassData.topics)) {
                questionList.push(...value);
            }

            const questionIndex = questionList.findIndex((item) => item.id === this.questionId);

            if (questionIndex !== -1) {
                this.questionIndex = questionIndex;
                this.currentQuestion = questionList[questionIndex];
            }
        },

        // 设置popover的状态
        setAnswerPoppver() {
            if (!this.$refs.correntAnswerRef) return;

            const dom = this.$refs.correntAnswerRef;
            this.questionAskPoppver = dom.scrollHeight > dom.clientHeight; // 如果内容大于容器高度。设置悬浮框可见
        },

        handleTypeChange(val) {
            this.type = val;
            this.getKnowledgeData();
        },

        handlePaperChange(val) {
            this.paper_id = val;
            this.getKnowledgeData();
        },

        resizeChart() {
            for (const [_, value] of this.chartMap) {
                value.resize();
            }
        },

        // 个人排名图表
        setPersonChart() {
            if (!this.$refs.knowledgePersonChartRef) return;
            const chart = this.$echarts.init(this.$refs.knowledgePersonChartRef);

            let xData = this.knowldegePersonData.list.map((item) => {
                const data = { s_id: item.s_id, s_name: item.s_name };
                return JSON.stringify(data);
            });
            let yData = this.knowldegePersonData.list.map((item) => item.score);

            const options = {
                grid: {
                    left: "3%",
                    right: "1%",
                    bottom: "30%",
                    top: "5%",
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        shadowStyle: {
                            opacity: 0,
                        },
                    },
                    borderWidth: 0,
                    backgroundColor: "#ffffff",
                    extraCssText:
                        "box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.08), 0px 16px 24px 2px rgba(0,0,0,0.04), 0px 6px 30px 5px rgba(0,0,0,0.05);",
                    formatter: function(params) {
                        const _params = params[0];
                        const xData = JSON.parse(_params.name);
                        const yData = _params.data;

                        return `
                            <div class="bar-tooltip">
                                <div class="tooltip-item">
                                    <div class="tooltip-item_title">${xData.s_name}</div>
                                    <div class="tooltip-item_score">
                                        <span>分数：</span>
                                        <span>${yData}</span>
                                    </div>
                                </div>
                            </div>
                        `;
                    },
                },
                xAxis: {
                    type: "category",
                    data: xData,
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                        },
                    },
                    axisLabel: {
                        formatter: function(params) {
                            const data = JSON.parse(params);
                            return data.s_name;
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    max: 100,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        lineStyle: {
                            type: "dashed",
                        },
                    },
                },
                series: [
                    {
                        data: yData,
                        type: "bar",
                        barMaxWidth: 24,
                        itemStyle: {
                            color: "#165DFF",
                        },
                    },
                ],
            };

            chart.setOption(options);

            if (!this.chartMap.has("knowledgePersonalChart")) {
                this.chartMap.set("knowledgePersonalChart", chart);
            }
        },

        // 班级数据图表
        setClassChart() {
            if (!this.$refs.knowledgeClassChartRef) return;
            const chart = this.$echarts.init(this.$refs.knowledgeClassChartRef);

            // let xData = this.knowldegePersonData.list.map((item) => {
            //     const data = { s_id: item.s_id, s_name: item.s_name };
            //     return JSON.stringify(data);
            // });
            // let yData = this.knowldegePersonData.list.map((item) => item.score);
            const questionList = [];
            for (const [_, value] of Object.entries(this.knowledgeClassData.topics)) {
                // 初始化第一条题目的id
                if (value.length > 0 && !this.questionId) {
                    this.questionId = value[0].id;
                    this.currentQuestion = value[0];
                }

                questionList.push(...value);
            }
            const xData = questionList.map((item) => JSON.stringify(item));
            const yData = questionList.map((item) => Number.parseFloat(item.student_answer_right_rate));

            const options = {
                grid: {
                    left: "3%",
                    right: "1%",
                    bottom: "30%",
                    top: "5%",
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        shadowStyle: {
                            opacity: 0,
                        },
                    },
                    borderWidth: 0,
                    backgroundColor: "#ffffff",
                    extraCssText:
                        "box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.08), 0px 16px 24px 2px rgba(0,0,0,0.04), 0px 6px 30px 5px rgba(0,0,0,0.05);",
                    formatter: function(params) {
                        const _params = params[0];
                        const data = JSON.parse(_params.name);

                        return `
                            <div class="bar-tooltip">
                                <div class="tooltip-item">
                                    <div class="tooltip-item_title">第${_params.dataIndex + 1}题</div>

                                    <div class="tooltip-item_score">
                                        <span>正确人数：</span>
                                        <span>${data.student_answer_right_num}</span>
                                    </div>

                                    <div class="tooltip-item_score">
                                        <span>错误人数：</span>
                                        <span>${data.student_answer_wrong_num}</span>
                                    </div>

                                    <div class="tooltip-item_score">
                                        <span>未做人数</span>
                                        <span>${data.student_no_answer_num}</span>
                                    </div>

                                    <div class="tooltip-item_score">
                                        <span>正确率：</span>
                                        <span>${data.student_answer_right_rate}</span>
                                    </div>
                                </div>
                            </div>
                        `;
                    },
                },
                xAxis: {
                    type: "category",
                    data: xData,
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                        },
                    },
                    axisLabel: {
                        formatter: function(params, index) {
                            return `第${index + 1}题`;
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    max: 100,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        lineStyle: {
                            type: "dashed",
                        },
                    },
                    axisLabel: {
                        formatter: function(params) {
                            return `${params}%`;
                        },
                    },
                },
                series: [
                    {
                        data: yData,
                        type: "bar",
                        barMaxWidth: 24,
                        itemStyle: {
                            color: "#165DFF",
                        },
                    },
                ],
            };

            chart.setOption(options);

            chart.getZr().on("mousemove", (params) => {
                let containPixel = [params.offsetX, params.offsetY];
                if (chart.containPixel("grid", containPixel)) {
                    const xIndex = chart.convertFromPixel({ seriesIndex: 0 }, containPixel)[0]; // 获取是第几个数据
                    const opData = chart.getOption();

                    const data = JSON.parse(opData.xAxis[0].data[xIndex]);

                    if (this.questionId !== data.id) {
                        this.questionId = data.id;
                        this.getQuestionDetail();
                    }
                }
            });

            if (!this.chartMap.has("knowledgeClassChart")) {
                this.chartMap.set("knowledgeClassChart", chart);
            }
        },
    },

    destroyed() {
        window.removeEventListener("resize", this.resizeChart);
    },
};
</script>

<style lang="scss" scoped>
::v-deep .bar-tooltip {
    padding: 14px;
    color: #333333;

    .tooltip-item {
        &:not(.tooltip-item:last-of-type) {
            margin-bottom: 10px;
        }

        &_title {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
        }

        &_score {
            min-width: 130px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // gap: 70px;
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
        }
    }
}

.knowledge-ranking {
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    background-color: #efefef;

    &_title {
        font-family: PingFang-SC, PingFang-SC;
        height: 24px;
        font-weight: 800;
        font-size: 24px;
        color: #333333;
        line-height: 24px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &_filter {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        // .filter-select {
        //     background-color: #f2f4f7;
        //     border-radius: 2px;
        //     overflow: hidden;

        //     .type-select {
        //         ::v-deep .el-input__inner {
        //             background-color: #006eff !important;
        //             color: #ffffff !important;
        //             border-top-left-radius: 4px;
        //             border-bottom-left-radius: 4px;
        //         }
        //     }

        //     .paper-select {
        //         ::v-deep .el-input__inner {
        //             border-bottom-right-radius: 4px;
        //             border-top-right-radius: 4px;
        //         }
        //     }
        // }

        .el-button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 88px;
            height: 36px;
        }

        .filter-select {
            display: flex;
            gap: 10px;
        }

        ::v-deep .el-input__inner {
            background-color: #ffffff !important;
        }

        // ::v-deep .el-input__inner {
        //     background-color: transparent !important;
        //     border: none;
        //     border-radius: 0;
        // }
    }

    &_box {
        height: calc(100vh - 212px);
        // background-color: #ffffff;

        ::v-deep .el-scrollbar__wrap {
            margin: 0 !important;

            &::-webkit-scrollbar {
                display: none;
            }
        }

        .score-item {
            width: calc((100% - 32px) / 3);
            height: 100%;
            background-color: #ffffff;
            border-radius: 8px;
            box-sizing: border-box;
            padding: 24px;
            overflow: hidden;

            &_top {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .top-label {
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #000000;
                    flex-shrink: 0;
                }

                .top-enter {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    cursor: pointer;

                    img {
                        width: 16px;
                        height: 16px;
                        object-fit: cover;
                    }

                    span {
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #006eff;
                        flex-shrink: 0;
                    }
                }
            }

            &_bottom {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 40px;
                position: relative;

                .progress-text {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 600;
                    font-size: 36px;
                    color: #000000;
                }
            }
        }

        .personal-ranking {
            height: calc(100vh - 212px);
            width: 100%;
            box-sizing: border-box;

            &_top {
                height: calc(100% - 306px);
                background-color: #ffffff;
                border-radius: 8px;
                box-sizing: border-box;
                padding: 24px;

                .top-title {
                    height: 24px;
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #26292e;
                    line-height: 24px;
                    margin-bottom: 50px;
                }

                .top-chart {
                    height: calc(100% - 74px);
                    // background-color: lightgray;
                }

                .box-empty {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    gap: 20px;

                    span {
                        height: 20px;
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        line-height: 16px;
                    }
                }
            }

            &_bottom {
                height: 286px;
                margin-top: 20px;
                display: flex;
                gap: 16px;
            }
        }

        .class-statictis {
            &_chart {
                height: 422px;
                padding: 24px;
                border-radius: 8px;
                background-color: #ffffff;

                .top-title {
                    height: 48px;
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #26292e;
                    line-height: 24px;
                    margin-bottom: 32px;
                    display: flex;
                    flex-direction: column;

                    .desc {
                        font-weight: 400;
                        font-size: 14px;
                        color: #6e7b91;
                        line-height: 20px;
                    }
                }

                .top-chart {
                    height: calc(100% - 80px);
                    // background-color: lightgray;
                }
            }

            &_question {
                padding: 24px;
                background-color: #ffffff;
                border-radius: 8px;
                margin-top: 20px;

                .question-detail {
                    display: flex;

                    &_index,
                    &_content .content-title {
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;
                        line-height: 20px;
                        letter-spacing: 2px;
                    }

                    &_index {
                        flex-shrink: 0;
                    }

                    &_content {
                        .content-title {
                            font-weight: 600;

                            & > * {
                                margin: 0 !important;
                                padding: 0 !important;
                            }
                        }

                        .content-answer {
                            .answer-item {
                                height: 20px;
                                font-family: PingFang-SC, PingFang-SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                line-height: 20px;
                                letter-spacing: 2px;
                                margin-top: 10px;

                                &:first-of-type {
                                    margin-top: 20px;
                                }
                            }
                        }
                    }
                }

                .question-statictis {
                    margin-top: 20px;
                    padding: 10px 16px;
                    background-color: #fcfcfc;
                    border-radius: 4px;
                    display: flex;
                    align-items: flex-start;
                    gap: 40px;

                    .statictis-item {
                        // height: 25px;
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        line-height: 25px;
                        flex-shrink: 0;

                        &:not(.current-answer) {
                            width: 80px;
                        }

                        &.current-answer {
                            max-width: calc(100% - 480px);

                            display: -webkit-box; /* 创建一个弹性盒子 */
                            -webkit-box-orient: vertical; /* 设置主轴为纵向 */
                            -webkit-line-clamp: 4; /* 限制显示4行 */
                            line-clamp: 4;
                            overflow: hidden; /* 隐藏多余的内容 */
                            text-overflow: ellipsis; /* 显示省略号 */
                            word-break: break-all;
                        }

                        &.current-rate {
                            text-wrap: nowrap;

                            .statictis-item_value {
                                color: #ff8000;
                            }
                        }

                        &.current-count {
                            .statictis-item_value {
                                color: #0acd00;
                            }
                        }

                        &.fail-count {
                            .statictis-item_value {
                                color: #ef0000;
                            }
                        }

                        &.no-make-count {
                            .statictis-item_value {
                                color: #a7a7a7;
                            }
                        }
                    }
                }
            }

            &_rate {
                margin-top: 20px;
                display: flex;
                gap: 16px;

                .score-item {
                    .question-type-4 {
                        height: 200px;
                        width: calc((100% - 48px) / 4);
                    }

                    .question-type-5 {
                        height: 200px;
                        width: calc((100% - 64px) / 5);
                    }
                }
            }
        }
    }
}
</style>
